import React from 'react';
import { FormattedMessage } from './FormattedMessage';

function ResultHeader({ header, searchString, nrOfHits }) {
  if (!header) return null;
  return (
    <div className="web-result-header">
      <span>
        <FormattedMessage
          text={header}
          // data-cs-mask is used to mask the search string for content square tracking
          // https://docs.contentsquare.com/en/web/personal-data-handling/#tagging-dom-elements
          values={{ query: <b data-cs-mask>{searchString}</b>, hits: nrOfHits }}
        />
      </span>
    </div>
  );
}

export default ResultHeader;
